const SET_RELATED_CONTENT = (state, payload) => {
  state.referenceData.relatedContent = payload.relatedContentByQuestionId;
};

export default SET_RELATED_CONTENT;
